import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NTwoDimensionalCarousel } from './two-dimensional-carousel.interface';

export const config = <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: NTwoDimensionalCarousel.ID,
    name: 'Two Dimensional Carousel',
    description: 'Two Dimensional Carousel component',
    tags: ['carousel'],
    fields: [
        <NICmsContentField.IRepeaterField>{
            key: 'sections',
            type: NICmsContentField.EFieldType.repeater,
            title: 'Sections',
            itemName: 'Section',
            itemNameField: 'name',
            fields: [
                <NICmsContentField.IField>{
                    key: 'name',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Name'
                },
                <NICmsContentField.IRepeaterField>{
                    key: 'items',
                    type: NICmsContentField.EFieldType.repeater,
                    title: 'Items',
                    itemName: 'Item',
                    fields: [
                        <NICmsContentField.IField>{
                            key: 'name',
                            type: NICmsContentField.EFieldType.text,
                            title: 'Name',
                            description: 'Name of item (optional)'
                        },
                        <NICmsContentField.IChoiceField>{
                            key: 'color',
                            type: NICmsContentField.EFieldType.choice,
                            title: 'Text Color',
                            description: 'Text color of navigation',
                            options: [
                                { key: '#FFF', title: 'White' },
                                { key: '#333333', title: 'Black' }
                            ],
                            default: '#333333'
                        },
                        <NICmsContentField.IField>{
                            key: 'bgColor',
                            type: NICmsContentField.EFieldType.colorPicker,
                            title: 'Background color',
                            default: '#fff'
                        },
                        <NICmsContentField.IComponentsField>{
                            key: 'components',
                            type: NICmsContentField.EFieldType.components,
                            title: 'Components',
                            itemName: 'Component',
                            default: []
                        },
                        <NICmsContentField.IField>{
                            key: 'hide',
                            type: NICmsContentField.EFieldType.checkbox,
                            title: 'Hide item',
                            default: false
                        }
                    ],
                    defaultSize: 1,
                    defaultPart: {
                        components: []
                    }
                },
                <NICmsContentField.IField>{
                    key: 'creative',
                    type: NICmsContentField.EFieldType.checkbox,
                    title: 'Creative Effect',
                    default: false
                },
                <NICmsContentField.IField>{
                    key: 'bulletsTitles',
                    type: NICmsContentField.EFieldType.checkbox,
                    title: 'Show Bullets Titles',
                    default: false
                },
                <NICmsContentField.IField>{
                    key: 'hide',
                    type: NICmsContentField.EFieldType.checkbox,
                    title: 'Hide section',
                    default: false
                }
            ],
            defaultSize: 1,
            defaultPart: {
                items: []
            }
        },
        <NICmsContentField.IField>{
            key: 'autoplay',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Carousel autoplay controls',
            default: false
        },
        <NICmsContentField.IField>{
            key: 'delay',
            type: NICmsContentField.EFieldType.number,
            title: 'Delay',
            description: 'Delay between transitions (in ms).',
            default: 5000,
            canShow: (data: NTwoDimensionalCarousel.IComponentData) => data.autoplay
        },
        <NICmsContentField.IField>{
            key: 'creative',
            type: NICmsContentField.EFieldType.checkbox,
            title: 'Creative Effect',
            default: false
        },
        <NICmsContentField.IField>{
            key: 'navigationBottom',
            type: NICmsContentField.EFieldType.checkbox,
            title: 'Bottom Navigation',
            default: false
        },
        <NICmsContentField.IField>{
            key: 'pageTop',
            type: NICmsContentField.EFieldType.checkbox,
            title: 'Page Top',
            description: 'Check if carousel is on top of the page',
            default: true
        }
    ]
};
